import React, { useEffect, useState } from 'react'
import '../../css/footer.css'
import Seen from '../../assest/footer/Saudi_Vision_2030_logo.svg.png';
import { Link } from 'react-router-dom';
function Footer() {
    const currentYear = new Date().getFullYear();
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 300) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    },[]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const scrollToPosition = () => {
        const isMobile = window.innerWidth <= 768;
        const scrollPosition = isMobile
            ? document.documentElement.scrollHeight / 4
            : document.documentElement.scrollHeight / 3;

        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
    };
    useEffect(()=>{
            if(window.location.pathname == '/home/all')
            {
                scrollToPosition();
            }
        },[Link])
    return (
        <footer>
            <div>
                <div className='footer-one'>
                    <div>
                        <h1>خطوة المستثمر</h1>
                        <p>حتماَ ستختار خطوة المستثمر لتميز خدماتنا وإبداعنا
                            <br />
                            المتواصل. عندما تختارنا فإنك تختار الجودة
                            <br />والخبرة التي اختارتها أكبر الشّركات في المملكة</p>
                    </div>
                    <div className='f-ourServices'>
                        <h1>خدماتنا</h1>
                        <ul>
                            <li><Link to='/home'>الرئيسية</Link></li>
                            <li><Link to='/about'>من نحن</Link></li>
                            <li><Link to='/home/all'>خدماتنا</Link></li>
                            <li><Link to='/about/contactus'>تواصل معنا</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h1>اتصل بنا</h1>
                        <ul>
                            <div>
                                <li><a href="tel:0547382666">
                                    <span>
                                        <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.3308 15.9402L15.6608 14.6101C15.8655 14.403 16.1092 14.2384 16.3778 14.1262C16.6465 14.014 16.9347 13.9563 17.2258 13.9563C17.517 13.9563 17.8052 14.014 18.0739 14.1262C18.3425 14.2384 18.5862 14.403 18.7908 14.6101L20.3508 16.1702C20.5579 16.3748 20.7224 16.6183 20.8346 16.887C20.9468 17.1556 21.0046 17.444 21.0046 17.7351C21.0046 18.0263 20.9468 18.3146 20.8346 18.5833C20.7224 18.8519 20.5579 19.0954 20.3508 19.3L19.6408 20.02C19.1516 20.514 18.5189 20.841 17.8329 20.9541C17.1469 21.0672 16.4427 20.9609 15.8208 20.6501C10.4691 17.8952 6.11008 13.5396 3.35083 8.19019C3.03976 7.56761 2.93414 6.86242 3.04914 6.17603C3.16414 5.48963 3.49384 4.85731 3.99085 4.37012L4.70081 3.65015C5.11674 3.23673 5.67937 3.00464 6.26581 3.00464C6.85225 3.00464 7.41488 3.23673 7.83081 3.65015L9.40082 5.22021C9.81424 5.63615 10.0463 6.19871 10.0463 6.78516C10.0463 7.3716 9.81424 7.93416 9.40082 8.3501L8.0708 9.68018C8.95021 10.8697 9.91617 11.9926 10.9608 13.04C11.9994 14.0804 13.116 15.04 14.3008 15.9102L14.3308 15.9402Z" stroke="#736E64" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M18.2109 8.84009C18.0578 8.09677 17.6931 7.41362 17.1609 6.87256C16.6288 6.33149 15.9516 5.95549 15.2109 5.79004" stroke="#736E64" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22 7.51001C21.6283 6.19924 20.928 5.00529 19.9655 4.04102C19.003 3.07674 17.8101 2.37408 16.5 2" stroke="#736E64" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>&nbsp;
                                    0547382666</a></li>
                            </div>
                            <div>
                                <li><a href="tel:0543150077">
                                    <span>
                                        <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.3308 15.9402L15.6608 14.6101C15.8655 14.403 16.1092 14.2384 16.3778 14.1262C16.6465 14.014 16.9347 13.9563 17.2258 13.9563C17.517 13.9563 17.8052 14.014 18.0739 14.1262C18.3425 14.2384 18.5862 14.403 18.7908 14.6101L20.3508 16.1702C20.5579 16.3748 20.7224 16.6183 20.8346 16.887C20.9468 17.1556 21.0046 17.444 21.0046 17.7351C21.0046 18.0263 20.9468 18.3146 20.8346 18.5833C20.7224 18.8519 20.5579 19.0954 20.3508 19.3L19.6408 20.02C19.1516 20.514 18.5189 20.841 17.8329 20.9541C17.1469 21.0672 16.4427 20.9609 15.8208 20.6501C10.4691 17.8952 6.11008 13.5396 3.35083 8.19019C3.03976 7.56761 2.93414 6.86242 3.04914 6.17603C3.16414 5.48963 3.49384 4.85731 3.99085 4.37012L4.70081 3.65015C5.11674 3.23673 5.67937 3.00464 6.26581 3.00464C6.85225 3.00464 7.41488 3.23673 7.83081 3.65015L9.40082 5.22021C9.81424 5.63615 10.0463 6.19871 10.0463 6.78516C10.0463 7.3716 9.81424 7.93416 9.40082 8.3501L8.0708 9.68018C8.95021 10.8697 9.91617 11.9926 10.9608 13.04C11.9994 14.0804 13.116 15.04 14.3008 15.9102L14.3308 15.9402Z" stroke="#736E64" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M18.2109 8.84009C18.0578 8.09677 17.6931 7.41362 17.1609 6.87256C16.6288 6.33149 15.9516 5.95549 15.2109 5.79004" stroke="#736E64" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22 7.51001C21.6283 6.19924 20.928 5.00529 19.9655 4.04102C19.003 3.07674 17.8101 2.37408 16.5 2" stroke="#736E64" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>&nbsp;
                                    0543150077</a></li>
                            </div>
                            <div>
                                <li><Link to="mailto:info@ptutd.com">
                                    <span>
                                        <svg width="25" height="25" viewBox="0 0 74 74" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M64.75 52.583C64.75 55.4114 64.7498 56.8264 63.8711 57.7051C62.9924 58.5834 61.5781 58.583 58.75 58.583H15.25C12.4219 58.583 11.0076 58.5834 10.1289 57.7051C9.25023 56.8264 9.25 55.4114 9.25 52.583V25.8105L36.0283 40.6885C36.6323 41.024 37.3677 41.024 37.9717 40.6885L64.75 25.8105V52.583ZM58.75 15.417C61.5781 15.417 62.9924 15.4166 63.8711 16.2949C64.7498 17.1736 64.75 18.5886 64.75 21.417V23.667C64.5855 23.6668 64.4187 23.7074 64.2646 23.793L37 38.9395L9.73535 23.793C9.58132 23.7074 9.41449 23.6668 9.25 23.667V21.417C9.25 18.5886 9.25023 17.1736 10.1289 16.2949C11.0076 15.4166 12.4219 15.417 15.25 15.417H58.75Z" fill="#736E64" />
                                        </svg>&nbsp;
                                    </span>
                                    info@ptutd.com</Link></li>
                            </div>
                        </ul>
                    </div>
                </div>
                <div className="footer-map">
                    <div className='map' width="100%">
                        <iframe
                            className='map'
                            src={"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4404.380780238425!2d46.68807167609331!3d24.542184578138418!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f0f0062f4b921%3A0xb056b3e02a58606a!2z2LTYsdmD2Kkg2K7Yt9mI2Kkg2KfZhNmF2LPYqtir2YXYsSDZhNiu2K_Zhdin2Kog2KfZhNij2LnZhdin2YQ!5e1!3m2!1sen!2ssa!4v1755351573443!5m2!1sen!2ssa"}
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="خريطة الموقع"
                        ></iframe>
                    </div>
                    <a href='https://www.vision2030.gov.sa/ar/' target='__blank'>
                        <img loading='lazy' src={Seen} width={200} height={200} alt="our-location" />
                    </a>
                </div>
                <div className='footer-copyRight'>
                    <p>جميع الحقوق محفوظة لدى شركة خطوة المستثمر
                        لخدمات الاعمال - {currentYear}
                    </p>
                </div>
            </div>
            {showButton && (
                <button onClick={scrollToTop} className='up'>
                    <svg width="25px" height="25px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M12 3C12.2652 3 12.5196 3.10536 12.7071 3.29289L19.7071 10.2929C20.0976 10.6834 20.0976 11.3166 19.7071 11.7071C19.3166 12.0976 18.6834 12.0976 18.2929 11.7071L13 6.41421V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V6.41421L5.70711 11.7071C5.31658 12.0976 4.68342 12.0976 4.29289 11.7071C3.90237 11.3166 3.90237 10.6834 4.29289 10.2929L11.2929 3.29289C11.4804 3.10536 11.7348 3 12 3Z" fill="#FFFFFF" />
                    </svg>
                </button>
            )}
        </footer>
    )
}

export default Footer